import { initStore } from "./store";

const configureStore = () => {
  const actions = {
    SET_OUTPUTBLOBURL: (state, payload) => {
      return { 
        // ...state,
        mlVoiceStore : {
          ...state.lmVoiceStore,
          outputBlobUrl: payload,
        }
      };
    },
    SET_TEXTTOSPEECHAPIEXIST: (state, payload) => {
      return { 
        // ...state,
        mlVoiceStore : {
          ...state.lmVoiceStore,
          textToSpeechApiExist: payload,
        }
      };
    },
    SET_ISVOICEGENERATING: (state, payload) => {
      return { 
        // ...state,
        mlVoiceStore : {
          ...state.lmVoiceStore,
          isVoiceGenerating: payload,
        }
      };
    },
  };

  initStore(actions, {
    mlVoiceStore: {
      outputBlobUrl: null,
      textToSpeechApiExist: false,
      // socketId: '',
      // isBackendApi: false,
      // isSScreen: false,
      isVoiceGenerating: false,
    }
  });
};

export default configureStore;
